export default {
  education: {
    webinar: {
      title: "Inscreva-se no evento para aceder à gravação",
      text: "Você pode fazer login automaticamente com os dados da sua conta atual ou inserir os dados manualmente na próxima etapa.",
      label: "Ao registar-se, aceita",
      link: "Termos de transferência para o parceiro de serviço MTS Link",
      close: "Introduzir os dados manualmente",
      submit: "Registo",
    },
    metaTitle: "Educação",
    noContentLang: "Não há materiais publicados nesta língua ainda",
    titles: {
      material: "Treinamento para médicos",
      course: "Cursos educacionais para médicos",
      simulator: "Simuladores para médicos",
      webinar: "Webinars para médicos",
    },
    filters: {
      selects: {
        type: {
          placeholder: "Tipo de materiais",
        },
        lang: {
          placeholder: "Idioma",
        },
        status: {
          placeholder: "Status",
          values: {
            actual: "Atuais",
            overpast: "Concluídos",
          },
        },
        specialty: {
          placeholder: "Especialidade",
        },
      },
      tabs: {
        material: "Todos os materiais",
        course: "Cursos",
        simulator: "Simuladores",
        webinar: "Webinars",
      },
    },
    content: {
      subtitles: {
        your: {
          material: "Seus materiais",
          course: "Seus cursos",
          simulator: "Seus simuladores",
          webinar: "Seus webinars",
        },
        recomended: {
          material: "Materiais recomendados",
          course: "Cursos recomendados",
          simulator: "Simuladores recomendados",
          webinar: "Webinars recomendados",
        },
      },
    },
  },
  Lessons: {
    Lesson: {
      title: "Lição",
      Files: "Anexos",
      DownloadAll: "Baixar tudo",
    },
    status: {
      success: "Concluído",
      unsuccess: "Não concluído",
      stop: "Indisponível",
    },
  },
  Tests: {
    table: {
      tests: "Testes",
      description: "Descrição",
      points: "Pontos",
      status: "Status",
    },
    modal: {
      title: "Você deseja finalizar o teste?",
    },
    questions: {
      question: "Pergunta",
      answer: "Resposta",
      correct: "Correto",
      incorrect: "Incorreto",
      moderated: "Em revisão",
      navigation: "Navegação do teste",
      enterAnswer: "Digite a resposta...",
    },
    errors: {
      required: "Pergunta obrigatória",
    },
    submit: "Finalizar teste",
    result: "Resultado",
    repeat: "Refazer",
  },
  afterPayCourse: {
    title: "Você obteve com sucesso o curso",
    text: "Agora você tem acesso aos materiais de treinamento",
    buttonText: "Ir para o curso",
  },
  coursePage: {
    courseType: {
      course: "Curso",
      simulator: "Aparelho de treino",
      webinar: "Webinar",
    },
    groupNumber: "{n}-th fluxo",
    manager: "Gerente",
    curator: "Curador",
    free: "Grátis",
  },
  coursesPage: {
    materials: "Material",
    schools: "Escolas de Autor",
    universities: "Universidade",
    showPast: "Mostrar o passado",
    emptyList: "Não existem tais materiais",
    show: "Mostrar",
    result1: "resultado",
    result2: "resultado",
    result5: "resultado",
    filters: "Filtro",
    clear: "Limpar",
  },
};
